import { 
    FieldBtn
} from './../../../dues/dues.style';
import React, { useState } from 'react'
import {  Checkbox, Dialog, Spinner, toaster } from 'evergreen-ui';
import {
    AppInputField,InputFieldTitleText,AppInputFieldSelect, AppInputFieldBtnCancel, AppInputFieldBtn
} from './../../../../../../widget/styledComponents/input_field.style'
import { gql, useMutation,useQuery } from '@apollo/client';
import Cookies from 'js-cookie';
import SubAdminCheckListPermissions from './permission_checklist_widget';
import { FETCH_ALL_ESTATE } from '../../../../pick_estate_btn';




// GraphQL mutation for adding a sub-admin
export const ADD_SUBADMIN = gql`
mutation SubAdmin_assign($managerName: String!, $managerEmail: String!, $managerPhone: String!, $facilityId: ID!, $fullAccess: Boolean!, $permissions: [SubAdminPermissionInput!]!) {
  subAdmin_assign(managerName: $managerName, managerEmail: $managerEmail, managerPhone: $managerPhone, facilityId: $facilityId, fullAccess: $fullAccess, permissions: $permissions) {
    code
    error
    success
    data {
      _id
      fullAccess
      inviteStatus
      isActive
      unassignedDate
      unassignedReason
      assignedDate
      permissions {
        fullAccess
        mutationAccess
        queryAccess
        resource
      }
    }
  }
}`;

export default function AddAdminButton() {
    const [isShown, setIsShown] = useState(false);
    const accesTokenValue = Cookies.get('userAccessToken');
    const [checked, setChecked] = useState(true); // Full access state
    const [dataObject, setDataObject] = useState({});
    const [permissions, setPermissions] = useState([]); // Custom permissions array

    const [addSubAdmin, { loading }] = useMutation(ADD_SUBADMIN);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setDataObject(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Update permissions from PermissionList component
    const handlePermissionsChange = (updatedPermissions) => {
        setPermissions(updatedPermissions);
    };

    // Handle the form submit
    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Set permissions based on full access or custom
        const finalPermissions = checked ? [
          {
            "resource":"dues",
            "fullAccess": true,
            "queryAccess": true,
            "mutationAccess": true
          },
          {
            "resource":"communication",
            "fullAccess": true,
            "queryAccess": true,
            "mutationAccess": true
          },
          {
            "resource":"complaints",
            "fullAccess": true,
            "queryAccess": true,
            "mutationAccess": true
          },
          {
            "resource":"owners",
            "fullAccess": true,
            "queryAccess": true,
            "mutationAccess": true
          },
          {
            "resource":"residents",
            "fullAccess": true,
            "queryAccess": true,
            "mutationAccess": true
          },
          {
            "resource":"security",
            "fullAccess": true,
            "queryAccess": true,
            "mutationAccess": true
          },
          {
            "resource":"properties",
            "fullAccess": true,
            "queryAccess": true,
            "mutationAccess": true
          },
          {
            "resource":"visitation",
            "fullAccess": true,
            "queryAccess": true,
            "mutationAccess": true
          },
        ] : permissions;

        // Prepare data for mutation
        const mutationVariables = {
            ...dataObject,
            fullAccess: checked,
            permissions: finalPermissions
        };

        console.log(mutationVariables,"--=-9--0-0")

        addSubAdmin({
            variables: mutationVariables,
            context: {
                headers: {
                    Authorization: `Bearer ${accesTokenValue}`,
                },
            },
        })
        .then((response) => {
            toaster.success("Sub-admin invite sent successfully.");
            setTimeout(() => window.location.reload(), 2000);
        })
        .catch((error) => {
            toaster.danger(error.message);
        });
    };

    // Handle the selection of a facility
    const handleOwnerSelect = (value) => {
        setDataObject(prev => ({
            ...prev,
            facilityId: value
        }));
    };

    return (
        <div>
            <Dialog
                isShown={isShown}
                title="Add Sub-Admin"
                onCloseComplete={() => setIsShown(false)}
                confirmLabel="Add"
                onConfirm={handleSubmit}
                hasFooter={false}
            >
                <form onSubmit={handleSubmit}>
                    <div className='row'>
                        <div className='col s12'>
                            <InputFieldTitleText>Name</InputFieldTitleText>
                            <AppInputField
                                type="text"
                                placeholder="alex iwobi"
                                name="managerName"
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className='col s12'>
                            <InputFieldTitleText>Email</InputFieldTitleText>
                            <AppInputField
                                type="text"
                                placeholder="example@gmail.com"
                                name="managerEmail"
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className='col s12'>
                            <InputFieldTitleText>Phone no</InputFieldTitleText>
                            <AppInputField
                                type="tel"
                                placeholder="+234"
                                name="managerPhone"
                                onChange={handleInputChange}
                                required
                            />
                        </div>

                        <div className='col s12'>
                            <InputFieldTitleText>Select facility to assign</InputFieldTitleText>
                            <PickFacility onSelect={handleOwnerSelect} />
                            <Checkbox 
                                checked={checked}
                                onChange={e => setChecked(e.target.checked)}
                                label="Full Access" 
                            />
                        </div>

                        {!checked && (
                            <div className='col s12'>
                                <SubAdminCheckListPermissions 
                                    onPermissionsChange={handlePermissionsChange} 
                                />
                            </div>
                        )}
                        
                        <div className='col s4 right mt-50' style={{ display: "flex", justifyContent: "end" }}>
                            <AppInputFieldBtn loading={loading}>Add</AppInputFieldBtn>
                        </div>
                        <div className='col s3 right' style={{ marginTop: "52px" }}>
                            <AppInputFieldBtnCancel onClick={() => setIsShown(false)}>Cancel</AppInputFieldBtnCancel>
                        </div>
                    </div>
                </form>
            </Dialog>

            <FieldBtn onClick={() => setIsShown(true)} class="waves-effect waves-light btn-flat">
                <i class="material-icons left">add</i>
                Add sub-admin
            </FieldBtn>
        </div>
    );
}

// Component for selecting a facility
const PickFacility = ({ onSelect }) => {
    const { loading, error, data } = useQuery(FETCH_ALL_ESTATE);
    const [selectedOption, setSelectedOption] = useState('');

    if (loading) return <Spinner />;
    if (error) return <p>Error: {error.message}</p>;

    const options = data.facilities;

    const handleSelect = (event) => {
        const selectedValue = event.target.value;
        setSelectedOption(selectedValue);
        onSelect(selectedValue);
    };

    return (
        <AppInputFieldSelect className="browser-default" required value={selectedOption} onChange={handleSelect}>
            <option value="" disabled>Choose your option</option>
            {options.map((option) => (
                <option key={option.id} value={option.id ?? option._id}>
                    {option.name}
                </option>
            ))}
        </AppInputFieldSelect>
    );
};
